import { Modal, Button } from 'antd';
import TableHistorial from './TableHistorial';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function DrawerHistorialVenta(props) {
    const { onClose, visible, venta_id } = props;
    const [folio, setFolio] = useState('');

    useEffect(() => {
        const fetchFolio = async () => {
            if (!venta_id) return;
            try {
                const res = await axios.get(`/venta/${venta_id}`);
                setFolio(res.data?.folio || '');
            } catch (err) {
                console.error('Error fetching folio de venta:', err);
            }
        };

        fetchFolio();
    }, [venta_id]);

    return (
        <Modal
            title={`Change History ${folio ? `- ${folio}` : ''}`}
            visible={visible}
            onCancel={onClose}
            closable={false}
            footer={
                <Button type="primary" onClick={onClose}>
                    Close
                </Button>
            }
            width={600}
            style={{ top: 50 }}
            bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
            centered
            destroyOnClose
        >
            <TableHistorial venta_id={venta_id} />
        </Modal>
    );
}
